import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Rôles du membre connecté, mis en cache 5 min (confort d'affichage uniquement).
 * Les portes de sécurité (Admin.tsx, RLS, fonctions) gardent leur propre vérification.
 */
export const useMyRoles = () => {
  const { user } = useAuth();
  const query = useQuery({
    queryKey: ["my-roles", user?.id],
    enabled: !!user,
    staleTime: 5 * 60_000,
    queryFn: async () => {
      const { data, error } = await supabase.from("user_roles").select("role").eq("user_id", user!.id);
      if (error) {
        console.error("Lecture des rôles impossible:", error);
        return [] as string[];
      }
      return (data ?? []).map((r) => r.role as string);
    },
  });
  const roles = query.data ?? [];
  return {
    roles,
    isAdmin: roles.includes("admin"),
    isPro: roles.includes("pro"),
    isLoading: !!user && query.isLoading,
  };
};
